/**
 * Fallback icon images for each content library media type.
 *
 * Drop Dan's lecture/discovery mode PNG assets into:
 *   assets/images/cm_mode_icons/<type>.png
 *
 * Once assets exist, uncomment the require() call for each type.
 * Until then, null causes ThumbnailCard to render a Material icon instead.
 */
export const cmModeIconMap: Partial<Record<string, any>> = {
  video: null, // require("../../../assets/images/cm_mode_icons/video.png"),
  pdf: null, // require("../../../assets/images/cm_mode_icons/pdf.png"),
  audio: null, // require("../../../assets/images/cm_mode_icons/audio.png"),
  image: null, // require("../../../assets/images/cm_mode_icons/image.png"),
  website: null, // require("../../../assets/images/cm_mode_icons/website.png"),
}
